import React from 'react';

const AwesomeIcon = () => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="15" cy="15" r="15" fill="#1ABC9C"/>
      <path d="M13.9844 7.5L11.4844 12.5H7.5V22.5H19.2773C20.1587 22.5 20.9277 21.8774 21.1133
        21.0156L22.4609 14.7656C22.7075 13.6108 21.8042 12.5 20.625 12.5H15.7617C15.8081 12.1094
        15.8179 11.7163 16.1133 10.8203C16.3037 10.2417 16.25 9.70947 16.25 9.375C16.25 8.90869
        16.062 8.479 15.7422 8.125C15.4224 7.771 14.9414 7.5 14.375 7.5H13.9844ZM14.6875
        8.90625C14.7266 8.93555 14.79 8.92578 14.8242 8.96484C14.9414 9.09424 15 9.27246 15
        9.375C15 9.78027 15.0122 10.1587 14.9219 10.4297C14.4556 11.8433 14.375 13.0859 14.375
        13.0859L14.3359 13.75H20.625C21.0376 13.75 21.3159 14.1089 21.2305 14.5117L19.9023
        20.7617C19.8389 21.0547 19.5752 21.25 19.2773 21.25H12.5V13.2812L14.6875 8.90625ZM8.75
        13.75H11.25V21.25H8.75V13.75ZM10 19.375C9.65576 19.375 9.375 19.6558 9.375 20C9.375
        20.3442 9.65576 20.625 10 20.625C10.3442 20.625 10.625 20.3442 10.625 20C10.625 19.6558
        10.3442 19.375 10 19.375Z" fill="white"/>
    </svg>
  );
};

export default AwesomeIcon;
